// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-content{background:#fff}.vue-notification{background:transparent;color:#000;font-size:14px}.vue-notification.success{background:#fff;border-left-color:#42a85f}.vue-notification.warn{background:#fff;border-left-color:#f48a06}.vue-notification.error{background:#fff;border-left-color:red}.vue-notification.info{background:#fff;border-left-color:#3670ff}body{overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
